import { fadeDownTransition as t } from "../../../_styles/transitions/fade-down.cssr.js";
import { cB as a, cE as r, cM as e, c as i } from "../../../_utils/cssr/index.js";
const o = a("form-item", `
 display: grid;
 line-height: var(--n-line-height);
`, [a("form-item-label", `
 grid-area: label;
 align-items: center;
 line-height: 1.25;
 text-align: var(--n-label-text-align);
 font-size: var(--n-label-font-size);
 min-height: var(--n-label-height);
 padding: var(--n-label-padding);
 color: var(--n-label-text-color);
 transition: color .3s var(--n-bezier);
 box-sizing: border-box;
 font-weight: var(--n-label-font-weight);
 `, [r("asterisk", `
 white-space: nowrap;
 user-select: none;
 -webkit-user-select: none;
 color: var(--n-asterisk-color);
 transition: color .3s var(--n-bezier);
 `), r("asterisk-placeholder", `
 grid-area: mark;
 user-select: none;
 -webkit-user-select: none;
 visibility: hidden; 
 `)]), a("form-item-blank", `
 grid-area: blank;
 min-height: var(--n-blank-height);
 `), e("auto-label-width", [a("form-item-label", "white-space: nowrap;")]), e("left-labelled", `
 grid-template-areas:
 "label blank"
 "label feedback";
 grid-template-columns: auto minmax(0, 1fr);
 grid-template-rows: auto 1fr;
 align-items: flex-start;
 `, [a("form-item-label", `
 display: grid;
 grid-template-columns: 1fr auto;
 min-height: var(--n-blank-height);
 height: auto;
 box-sizing: border-box;
 flex-shrink: 0;
 flex-grow: 0;
 `, [e("reverse-columns-space", `
 grid-template-columns: auto 1fr;
 `), e("left-mark", `
 grid-template-areas:
 "mark text"
 ". text";
 `), e("right-mark", `
 grid-template-areas: 
 "text mark"
 "text .";
 `), e("right-hanging-mark", `
 grid-template-areas: 
 "text mark"
 "text .";
 `), r("text", `
 grid-area: text; 
 `), r("asterisk", `
 grid-area: mark; 
 align-self: end;
 `)])]), e("top-labelled", `
 grid-template-areas:
 "label"
 "blank"
 "feedback";
 grid-template-rows: minmax(var(--n-label-height), auto) 1fr;
 grid-template-columns: minmax(0, 100%);
 `, [e("no-label", `
 grid-template-areas:
 "blank"
 "feedback";
 grid-template-rows: 1fr;
 `), a("form-item-label", `
 display: flex;
 align-items: flex-start;
 justify-content: var(--n-label-text-align);
 `)]), a("form-item-blank", `
 box-sizing: border-box;
 display: flex;
 align-items: center;
 position: relative;
 `), a("form-item-feedback-wrapper", `
 grid-area: feedback;
 box-sizing: border-box;
 min-height: var(--n-feedback-height);
 font-size: var(--n-feedback-font-size);
 line-height: 1.25;
 transform-origin: top left;
 `, [i("&:not(:empty)", `
 padding: var(--n-feedback-padding);
 `), a("form-item-feedback", {
  transition: "color .3s var(--n-bezier)",
  color: "var(--n-feedback-text-color)"
}, [e("warning", {
  color: "var(--n-feedback-text-color-warning)"
}), e("error", {
  color: "var(--n-feedback-text-color-error)"
}), t({
  fromOffset: "-3px",
  enterDuration: ".3s",
  leaveDuration: ".2s"
})])])]);
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/form/src/styles/form-item.cssr.js
// module id = 1690
// module chunks = 67